import { HttpParams } from '@angular/common/http';
import type { ComplexPaginatedDataRequest } from '@app/models/shared.models';

export const buildBasicListRequestParams = (
  params: ComplexPaginatedDataRequest = {}
): HttpParams => {
  let httpParams = new HttpParams();

  if (params.skip != null) {
    httpParams = httpParams.set('skip', String(params.skip));
  }

  if (params.take != null) {
    httpParams = httpParams.set('take', String(params.take));
  }

  if (params.sort?.length) {
    httpParams = httpParams.set('sort', JSON.stringify(params.sort));
  }

  const filter = params.filter?.trim();
  if (filter) {
    httpParams = httpParams.set('filter', filter);
  }

  return httpParams;
};
